// Hosted legal documents (Firebase Storage, public-read `legal/` path — see
// storage.rules). These open in the device browser from the signup consent
// step and from Settings, so they MUST be reachable unauthenticated.
//
// Stable, tokenless download URLs: because storage.rules grants `read: if
// true` on `legal/{fileName}`, the plain `?alt=media` URL (no download
// token) works forever and never changes when the file is re-uploaded.
//
// IMPORTANT — keep LEGAL_VERSION and the hosted PDF in lockstep. Replacing
// the PDF at the same path silently changes what EVERY installed app shows,
// while each build records the LEGAL_VERSION it was compiled with. So:
//   - Non-material fixes (typos, formatting): re-upload at the same path, no
//     version bump — the recorded consent version still describes the terms.
//   - MATERIAL changes (anything altering the agreement): bump LEGAL_VERSION
//     below AND ship a new build (and typically re-prompt existing users),
//     so `legal_version` on each user doc keeps identifying what they
//     actually agreed to. Do NOT rely on silently swapping the PDF for a
//     material revision. Keep the object names in sync with
//     scripts/upload-legal-docs.js.
const STORAGE_BUCKET = "vibelink-f7767.firebasestorage.app";

function legalUrl(objectName) {
  return `https://firebasestorage.googleapis.com/v0/b/${STORAGE_BUCKET}/o/${encodeURIComponent(
    objectName
  )}?alt=media`;
}

export const PRIVACY_POLICY_URL = legalUrl("legal/privacy-policy.pdf");
export const TERMS_URL = legalUrl("legal/terms-and-conditions.pdf");

// Stamped onto the user doc at signup (authService) so there's a durable
// record of WHICH version each account accepted. Bump this whenever the
// documents are materially revised.
export const LEGAL_VERSION = "AUG-2026";
